import {FC} from "react";
import {usePermissions} from "../../../resources/PermissionsHook";
import {useNavigate} from "react-router-dom";
import {SettingsContainer} from "../SettingsPage";
import {Card} from "@jane/lib/src/components/Card";
import {Button} from "@jane/lib/src/components/form/Button";

export const SocialCardPreferences: FC<{}> = () => {
  const {canManageSocialCards} = usePermissions()
  const navigate = useNavigate()
  if (!canManageSocialCards) {
    return <></>
  }
  return <SettingsContainer title={"Sociale kaarten"}
                            description={"Per locatie kan een sociale kaart worden ingesteld. Per locatie die een sociale kaart heeft kan naast de link naar de kaart, een afbeelding van de regio worden toegevoegd."}>
    <Card title={'Sociale kaarten'}>
      <Button type={"primary"} size={'sm'} onClick={() => navigate('/settings/social_card')}
              text={'Sociale kaarten instellen'}/>
    </Card>
  </SettingsContainer>
}